import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives/directives.module';
import { ChipsInputModule } from '../chips-input/chips-input.module';
import { ListSelectionModule } from '../list-selection/list-selection.module';
import { SphereRadiusChipsComponent } from './sphere-radius-chips.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
        DirectivesModule,
        ListSelectionModule,
        ChipsInputModule,
    ],
    exports: [SphereRadiusChipsComponent],
    declarations: [SphereRadiusChipsComponent],
})
export class SphereRadiusChipsModule {}
